module.exports = __webpack_public_path__ + "img/sleep_tag3.bf993083.png";